// Generated by ts-to-zod
import { z } from "zod";
import { PersonalInformationBlockMode } from "./../../../types/next/blocks/personalInformationBlock";

import { referenceIdSchema } from "./ids.zod";
import { blockReferenceSchema } from "./references.zod";
import { iBlockSchema, blockBaseSettingsSchema } from "./baseBlock.zod";

import { BLOCK_TYPE } from "../../../types/next";

export const personalInformationBlockReferencesSchema =
  blockReferenceSchema.extend({
    meaning: z.union([z.literal("address autofill"), z.literal("contact")]),
  });

export const commonFieldSettingsSchema = z.object({
  display: z.boolean(),
  required: z.boolean(),
  options: z.array(z.string()).optional(),
  default: z.string().optional(),
});

export const personalInformationBlockModeSchema = z.nativeEnum(
  PersonalInformationBlockMode,
);

export const privatePIBlockFieldsSchema = z.object({
  salutation: commonFieldSettingsSchema,
  title: commonFieldSettingsSchema,
  firstName: commonFieldSettingsSchema,
  lastName: commonFieldSettingsSchema,
  email: commonFieldSettingsSchema,
  telephone: commonFieldSettingsSchema,
  birthDate: commonFieldSettingsSchema,
});

export const businessPIBlockFieldsSchema = z.object({
  companyName: commonFieldSettingsSchema,
  registryCourt: commonFieldSettingsSchema,
  registerNumber: commonFieldSettingsSchema,
});

export const privatePIBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.PERSONAL_INFORMATION),
  settings: blockBaseSettingsSchema.and(
    z.object({
      mode: z.literal(PersonalInformationBlockMode.PRIVATE),
      fields: privatePIBlockFieldsSchema,
      purpose: z.array(z.string()),
    }),
  ),
  references: z.record(
    referenceIdSchema,
    personalInformationBlockReferencesSchema,
  ),
});

export const businessPIBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.PERSONAL_INFORMATION),
  settings: blockBaseSettingsSchema.and(
    z.object({
      mode: z.literal(PersonalInformationBlockMode.BUSINESS),
      fields: privatePIBlockSchema.and(businessPIBlockFieldsSchema),
      purpose: z.array(z.string()),
    }),
  ),
  references: z.record(
    referenceIdSchema,
    personalInformationBlockReferencesSchema,
  ),
});

export const userDefinedPIBlockSchema = iBlockSchema.extend({
  type: z.literal(BLOCK_TYPE.PERSONAL_INFORMATION),
  settings: blockBaseSettingsSchema.and(
    z.object({
      mode: z.literal(PersonalInformationBlockMode.USER_DEFINED),
      fields: privatePIBlockSchema.and(businessPIBlockFieldsSchema),
      purpose: z.array(z.string()),
    }),
  ),
  references: z.record(
    referenceIdSchema,
    personalInformationBlockReferencesSchema,
  ),
});

export const personalInformationBlockSchema = z.union([
  privatePIBlockSchema,
  businessPIBlockSchema,
  userDefinedPIBlockSchema,
]);

export const personalInformationValueSchema = z.object({
  salutation: z.string().optional(),
  title: z.string().optional(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  birthDate: z.union([z.date(), z.string()]).optional(),
  email: z.string().optional(),
  telephone: z.string().optional(),
  customerType: z.string().optional(),
  companyName: z.string().optional(),
  registryCourt: z.string().optional(),
  registerNumber: z.string().optional(),
});
